<template>
  <div >
    <jListCompanyLocation
      ref="locationTable"
      @edit-modal="openModalUpdate"
      @create-modal="openModalCreate"
      @detail-location="getLocationDetail"/>
    <b-modal
      ref="modalForm"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <div>
        <j-form-company-location
          v-if="isOpen"
          :mode="mode"
          :detail="company_location"
          @updated="refreshList"
          @close-modal="closeModalForm"/>
      </div>
    </b-modal>
  </div>
</template>
<script>
import jFormCompanyLocation from './jFormCompanyLocation';
import jListCompanyLocation from './jListCompanyLocation';

export default {
  components: {
    jFormCompanyLocation,
    jListCompanyLocation,
  },
  data() {
    return {
      isOpen: false,
      mode: 'create',
      company_location: null,
    };
  },
  methods: {
    getLocationDetail(data) {
      this.company_location = data;
    },
    closeModalForm() {
      this.$refs.modalForm.hide();
      this.isOpen = false;
    },
    openModalCreate(data) {
      if (data) {
        this.isOpen = true;
        this.mode = 'create';
        this.company_location = null;
        this.$refs.modalForm.show();
      }
    },
    openModalUpdate(data) {
      if (data) {
        this.isOpen = true;
        this.mode = 'edit';
        this.$refs.modalForm.show();
      }
    },
    refreshList() {
      setTimeout(() => {
        this.$refs.locationTable.refreshTable();
      }, 0);
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/views/location/jCompanyLocation.vue